"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownload = exports.downloadFile = exports.fakeClick = void 0;
const use_repository_1 = require("./use-repository");
const fakeClick = (obj) => {
    const ev = document.createEvent('MouseEvents');
    ev.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    obj.dispatchEvent(ev);
};
exports.fakeClick = fakeClick;
const downloadFile = (name, repositoryUrl) => {
    const saveLink = document.createElement('a');
    saveLink.href = `${repositoryUrl}${name}?download`;
    exports.fakeClick(saveLink);
};
exports.downloadFile = downloadFile;
/**
 * Custom hook that downloads a specified content from a repository
 * Has to be wrapped with **RepositoryContext**
 */
const useDownload = (content) => {
    const repo = use_repository_1.useRepository();
    const isFile = repo.schemas.isContentFromType(content, 'File');
    return {
        /**
         * Boolean that indicates if the content is a File
         */
        isFile,
        /**
         * Callback that will trigger the download
         */
        download: () => exports.downloadFile(content.Path, repo.configuration.repositoryUrl),
    };
};
exports.useDownload = useDownload;
//# sourceMappingURL=use-download.js.map